import s from "./DualImage.module.css"
import ImgWithFallbackInMarkdown from "./ImgWithFallbackInMarkdown"

const DualImage = (props) => {
  const { src1, src2, alt1, alt2 } = props

  return (
    <div className={s.wrapper}>
      <div className={s.image}>
        <ImgWithFallbackInMarkdown src={src1} alt={alt1} />
      </div>
      <div className={s.image}>
        <ImgWithFallbackInMarkdown src={src2} alt={alt2} />
      </div>
    </div>
  )
}

export default DualImage
